import Select from '@ben/orion/deprecated-select';
import Input from '@ben/orion/input';
import { Controller, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../../shared/constants';

interface IModularFileUploadInputProps {
  componentControllerName: string;
}

const ModularFileUploadInput = ({
  componentControllerName,
}: IModularFileUploadInputProps) => {
  const { control } = useFormContext();
  return (
    <Wrapper>
      <Controller
        control={control}
        name={`${componentControllerName}.maxFileSize`}
        render={({ field }) => (
          <Input
            {...field}
            name="Max file size (MB) (optional)"
            type="number"
          />
        )}
      />
      <Controller
        control={control}
        name={`${componentControllerName}.maxFilesNumber`}
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            name="Max files number"
            type="number"
            hasError={!!error}
            errorMessage={error?.message}
          />
        )}
        rules={{
          required: fieldCannotBeBlankErrorMessage,
        }}
      />
      <Controller
        control={control}
        name={`${componentControllerName}.acceptedTypes`}
        render={({ field, fieldState }) => (
          <Select
            {...field}
            name="Accepted file types"
            options={[
              { key: 'PDF', label: 'PDF' },
              { key: 'SPREADSHEET', label: 'Spreadsheet' },
              { key: 'IMAGE', label: 'Image' },
              { key: 'TEXT_DOCUMENT', label: 'Text Document' },
            ]}
            defaultValue={field.value ?? []}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message}
          />
        )}
        rules={{ required: fieldCannotBeBlankErrorMessage }}
      />
    </Wrapper>
  );
};

export default ModularFileUploadInput;

const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
